import { render, staticRenderFns } from "./PlayerInventory.vue?vue&type=template&id=7c83fe5c"
import script from "./PlayerInventory.vue?vue&type=script&lang=js"
export * from "./PlayerInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports